<template>
<div class="table_container">
  <el-table :data="promotionData" size="mini">
    <el-table-column prop="name" label="Competition" class-name="promotion-topic-name" />
    <el-table-column prop="entries" label="Entries" width="75" />
    <el-table-column prop="uniques" label="Uniques" width="75" />
  </el-table>
</div>
</template>

<script>
import accounting from 'accounting';

const formatNumber = x => accounting.formatNumber(x, 0, ' ');

export default {
  name: 'PromotionsTable',

  props: {
    data: {
      type: Array,
      required: true,
    },
  },

  computed: {
    promotionData() {
      return this.data.map(x => ({
        ...x,
        entries: formatNumber(x.entries),
        uniques: formatNumber(x.uniques),
      }));
    },
  },
};
</script>

<style lang="scss" scoped>
.promotion-topic-name {
  font-weight: bold;
}

.table_container {
  max-height: 220px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>




// WEBPACK FOOTER //
// PromotionsTable.vue?26c88a6c